import { Button } from '@/components/ui/button'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  activityRetentionCaption,
  activityRetentionLinks,
  activityRetentionOptions,
  type ActivityRetentionYears,
} from './activityRetention'

export function ActivityRetentionSelect({
  id,
  value,
  onChange,
  label = 'Activity retention',
  disabled = false,
}: {
  id: string
  value: ActivityRetentionYears
  onChange: (value: ActivityRetentionYears) => void
  label?: string
  disabled?: boolean
}) {
  return (
    <Select
      disabled={disabled}
      value={value === null ? 'all' : String(value)}
      onValueChange={(next) => {
        const option = activityRetentionOptions.find((item) => item.value === next)
        if (option) onChange(option.years)
      }}
    >
      <SelectTrigger id={id} className="h-9 w-full" aria-label={label}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {activityRetentionOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}

export function ActivityRetentionHelp({ country }: { country?: string | null }) {
  const link = activityRetentionLinks[country ?? '']
  return (
    <>
      {activityRetentionCaption}
      {link && (
        <>
          {' '}
          <Button variant="link" size="inline" asChild>
            <a href={link.href} target="_blank" rel="noreferrer">
              {link.text}
            </a>
          </Button>
        </>
      )}
    </>
  )
}
